module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "text-center py-3 bold"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', [_vm._v("\n        An error occurred when trying to create an Invoice (#" + _vm._s(_vm.info.metadata.productId) + "-" + _vm._s(_vm.info.metadata.eventId) + ")"), _c('br'), _vm._v("\n        It seems there are some missing or incorrect information coming from " + _vm._s(_vm.info.metadata.invoiceSystemName) + ". Please check your configurations.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.info.metadata.productName))]), _vm._v(" "), _c('div', [_vm._v("VAT: " + _vm._s(_vm.info.metadata.invoiceVAT))]), _vm._v(" "), _c('div', [_vm._v("Family: " + _vm._s(_vm.info.metadata.invoiceFamily))]), _vm._v(" "), _c('div', [_vm._v("CostCenter: " + _vm._s(_vm.info.metadata.invoiceCostCenter))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "btn action wide w-100",
    on: {
      "click": _vm.clickedOk
    }
  }, [_vm._v("OK")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-196c22ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196c22ae"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/richPrompt/templates/invoiceMissingConf.vue
// module id = 1461
// module chunks = 0